import { toast } from "react-toastify"
import { saveAs } from 'file-saver'
// import { dvSrv } from '../hook/useDeepvinApi';
import useDeepVinApi from '../hook/useDeepvinApi';
import { getCurrentTimeString, toUrlSafeBase64 } from './utils';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFilePdf } from "@fortawesome/free-regular-svg-icons";

// Deprecated: The API endpoint for exporting all videos by team does not match.
export const ExportPDFButton = () => {
    const api = useDeepVinApi()
    const fetchPDFData = async () => {
        try {
            const response = await api.get('/api/video/export', { responseType: 'blob' , withCredentials: true})
            const pdfBlob = new Blob([response.data], { type: 'application/pdf' })
            
            saveAs(pdfBlob, 'VideosByTeam.pdf')

        } catch (error) {
            console.error("Error fetching PDF from server:", error)
        }
    }

    return (
        <button class="btn btn-primary w-80 py-2" onClick={fetchPDFData} aria-expanded="false">
            Export
        </button>
    )
}

export const ExportReportsButton = ({startDate, endDate, templateType}) => {
    const api = useDeepVinApi()
    
    const exportReport = () => {

        api.get('/api/report/export', { 
            params: {
                    startDate,
                    endDate,
                    templateType,
                },
            responseType: 'blob', 
            withCredentials: true})
            .then(({data}) => {
                const csvBlob = new Blob([data], { type: 'text/csv' })
        
                saveAs(csvBlob, getCurrentTimeString()+'_'+templateType+'.csv')
                // toast.success("Export reports data done!")
            })
            .catch((error) => {
                toast.error("Export reports data failed: " + error?.response?.data?.error)
                console.error("Error exporting reports data:", error)
            })
    }

    return (
        <button class="btn btn-secondary w-80 py-1 mt-3 mb-3" onClick={exportReport} aria-expanded="false">
            Export Data as CSV
        </button>
    )
}

export const ExportCaseReportButton = ({caseNum, ...props}) => {
    const api = useDeepVinApi()
    const encodedCN = toUrlSafeBase64(caseNum)
    const exportCaseReport = async () => {
        try {
            const response = await api.get(`/api/report/${encodedCN}/export`, { responseType: 'blob' , withCredentials: true})
            const pdfBlob = new Blob([response.data], { type: 'application/pdf' })
            
            saveAs(pdfBlob, caseNum +'_report.pdf')

        } catch (error) {
            console.error("Error exporting case report PDF from server:", error)
        }
    }

    return (
        <button {...props}
          onClick={exportCaseReport} aria-expanded="false">
            <FontAwesomeIcon icon={faFilePdf}/>
        </button>
    )
}
